import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Props } from './NetworkBar';
import { initialFetch } from './redux/actions';
import {
  getCanUserHaveWatchedGroups,
  getMainNavItems,
  getIsNetworkBarInitialized,
  getCanUserHaveRecommendedGroups,
} from './redux/selectors';
import { getCanUserSeeWatch, getIsMobile } from '../publicSession/selectors';

export type StateProps = Pick<
  Props,
  | 'showWatchedGroupsEmptyState'
  | 'showRecommendedGroups'
  | 'mainNavItems'
  | 'isInitialized'
  | 'canSeeOldWatch'
  | 'canSeeShop'
>;
export type DispatchProps = Pick<Props, 'initialFetch'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = state => ({
  showWatchedGroupsEmptyState: !getCanUserHaveWatchedGroups(state),
  showRecommendedGroups: getCanUserHaveRecommendedGroups(state),
  mainNavItems: getMainNavItems(state),
  isInitialized: getIsNetworkBarInitialized(state),
  canSeeOldWatch: getCanUserSeeWatch(state),
  canSeeShop: getIsMobile(state), // on desktop it's shown in the siteheader
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  initialFetch,
};

export default connect(mapStateToProps, mapDispatchToProps);
